import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import zhCN from 'antd/lib/locale/zh_CN';
import {ConfigProvider} from 'antd';
import 'antd/dist/antd.variable.min.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {Provider} from 'react-redux';
import store from './redux';
import './icons/index';
import moment from "moment";
import 'moment/locale/zh-cn';
moment.locale('zh-cn');
ReactDOM.render(
    <Provider store={store}>
        <ConfigProvider locale={zhCN}>
            <App/>
        </ConfigProvider>
    </Provider>
    ,
    document.getElementById('root')
);

reportWebVitals();
